import { createContext, useContext } from "react";

export const WireAnswersContext = createContext<{
  answers: Record<string, unknown>;
  setAnswer: (name: string, value: unknown) => void;
} | null>(null);

export function useWireAnswers() {
  const ctx = useContext(WireAnswersContext);
  if (!ctx) {
    throw new Error("useWireAnswers must be used within WireAnswersContext.Provider");
  }
  return ctx;
}
